export type UsernameValidationErrorCode = "REQUIRED" | "FORMAT" | "UNCHANGED";

export type UsernameValidationResult = {
  isValid: boolean;
  normalizedValue: string;
  errorCode: UsernameValidationErrorCode | null;
};

const USERNAME_PATTERN = /^[A-Za-z0-9][A-Za-z0-9_.@$+-]{4,99}$/;

export const validateUsername = (
  usernameValue: string,
  currentUsername?: string
): UsernameValidationResult => {
  const normalizedValue = (usernameValue || "").trim();

  if (!normalizedValue) {
    return {
      isValid: false,
      normalizedValue,
      errorCode: "REQUIRED",
    };
  }

  if (currentUsername && normalizedValue === currentUsername) {
    return {
      isValid: false,
      normalizedValue,
      errorCode: "UNCHANGED",
    };
  }

  if (!USERNAME_PATTERN.test(normalizedValue)) {
    return {
      isValid: false,
      normalizedValue,
      errorCode: "FORMAT",
    };
  }

  return {
    isValid: true,
    normalizedValue,
    errorCode: null,
  };
};
